// extracted by mini-css-extract-plugin
export default {"select":"InputSelect_select__0OjWA","noIcon":"InputSelect_noIcon__ClLBF"};